<glxy-form-field>
  <glxy-label>
    {{ label | translate }}
  </glxy-label>
  <mat-chip-grid #chipList aria-label="Insert your text">
    <mat-chip-row *ngFor="let text of getSelectedValue()" [removable]="true" (removed)="remove(text)">
      <span class="chip-text">{{ text }}</span>
      <mat-icon matChipRemove class="mat-chip-remove">cancel</mat-icon>
    </mat-chip-row>
    <input
      matInput
      [placeholder]="'AUTOMATIONS.EDITOR.FILTERS.CUSTOM_DATA.DATA_LABELS.ENTER_TEXT' | translate"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="true"
      (matChipInputTokenEnd)="add($event)"
    />
  </mat-chip-grid>
  <glxy-error *ngIf="chipList.errorState">
    {{ 'AUTOMATIONS.EDITOR.FILTERS.CUSTOM_DATA.ERRORS.FREE_TEXT_REQUIRED' | translate }}
  </glxy-error>
</glxy-form-field>
